import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { DateService } from "./shared/services/date-service";

import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from "@angular/common/http";
import { FormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { IconsProviderModule } from "./icons-provider.module";

import { OverlayModule } from "@angular/cdk/overlay";
import { DatePipe, DecimalPipe, registerLocaleData } from "@angular/common";
import en from "@angular/common/locales/en";
import { MatIconModule } from "@angular/material/icon";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatLegacyCardModule as MatCardModule } from "@angular/material/legacy-card";
import { MatLegacyProgressBarModule as MatProgressBarModule } from "@angular/material/legacy-progress-bar";
import { MatToolbarModule } from "@angular/material/toolbar";
import { StorageModule } from "@ngx-pwa/local-storage";
import { NgxChartsModule } from "@swimlane/ngx-charts";
import { NZ_I18N, en_US } from "ng-zorro-antd/i18n";
import { NzModalService } from "ng-zorro-antd/modal";
import { QuillModule } from "ngx-quill";
import {
  AuthGuard,
  CreditorsGuard,
  LeadGuard,
  LogsGuard,
  ModalService,
  OutGuard,
  PayGuard,
  PendingGuard,
  ProgramGuard,
  RoleGuard,
  SettleGuard,
  UsersGuard,
  ViewsGuard,
} from "./shared";
import { AuthService } from "./shared/services/auth.service";
import { BaseService } from "./shared/services/base.services";
import { HttpInterceptService } from "./shared/services/http-interceptor.service";
import { LocalDataService } from "./shared/services/localData.service";
import { StorageService } from "./shared/services/storage.services";
import { UserService } from "./shared/services/user.service";
import { Setting } from "./shared/setting";

import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatLegacyFormFieldModule as MatFormFieldModule } from "@angular/material/legacy-form-field";
import { MatLegacyInputModule as MatInputModule } from "@angular/material/legacy-input";
import { CustomersModule } from "./components/customers/customers.module";
import { DatesService } from "./core/base/services/dates.service";
import { LeadUtilsService } from "./core/base/services/lead-util.service";
import { NumerosALetras } from "./shared/services/numeros.service";
import { SharedModule } from "./shared/shared.module";
// 📌 Importaciones de NG-ZORRO
import { NzCardModule } from "ng-zorro-antd/card";
import { NzIconModule } from "ng-zorro-antd/icon";
import { NzTableModule } from "ng-zorro-antd/table";
import { NzTypographyModule } from "ng-zorro-antd/typography";

// 📌 Importar ngx-echarts correctamente
import { NgxEchartsModule } from "ngx-echarts";
registerLocaleData(en);

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgxEchartsModule, // 📌 Registro correcto de ngx-echarts
    NzCardModule,
    NzTableModule,
    NzIconModule,
    NzTypographyModule,
    OverlayModule,
    SharedModule,
    IconsProviderModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    MatProgressBarModule,
    MatDatepickerModule,
    FormsModule,
    QuillModule.forRoot(),
    HttpClientModule,
    NgxChartsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    BrowserAnimationsModule,
    StorageModule.forRoot({ IDBNoWrap: true }),

    CustomersModule,
  ],
  providers: [
    AuthGuard,
    OutGuard,
    LeadGuard,
    PendingGuard,
    ProgramGuard,
    PayGuard,
    UsersGuard,
    DatesService,
    RoleGuard,
    ViewsGuard,
    SettleGuard,
    LogsGuard,
    HttpInterceptService,
    CreditorsGuard,

    DatePipe,
    DecimalPipe,
    ModalService,
    NumerosALetras,
    DateService,
    AuthService,
    NzModalService,
    UserService,
    StorageService,
    LocalDataService,
    BaseService,
    Setting,
    LeadUtilsService,
    { provide: HTTP_INTERCEPTORS, useClass: HttpInterceptService, multi: true },
    { provide: NZ_I18N, useValue: en_US },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
